var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircleTick = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M70.6173 130.495C103.908 130.495 130.895 103.508 130.895 70.2179C130.895 36.9276 103.908 9.94043 70.6173 9.94043C37.327 9.94043 10.3398 36.9276 10.3398 70.2179C10.3398 103.508 37.327 130.495 70.6173 130.495Z",
    fill: "#5C6CFC",
    stroke: "#42B5AA",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6173 130.495C103.908 130.495 130.895 103.508 130.895 70.2179C130.895 36.9276 103.908 9.94043 70.6173 9.94043C37.327 9.94043 10.3398 36.9276 10.3398 70.2179C10.3398 103.508 37.327 130.495 70.6173 130.495Z",
    stroke: "#5C6CFC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5566 77.3855L60.6776 93.4947L97.7841 56.3765",
    stroke: "#5C6CFC",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleTick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle-tick.831785a00a8df4cb7740b3aff8e6e554.svg";